export default __webpack_public_path__ + "static/media/36I-102777_-43416_0.f7ea94a3.jpg";